import { useCallback } from 'react';
import { useAppContext } from '@/context/AppContext';
import { useFileManager } from '@/hooks/useFileManager';

export function SaveButtons() {
  const { state } = useAppContext();
  const [, fileActions] = useFileManager();

  const handleSave = useCallback(async () => {
    if (!state.xmlDoc) {    
      return;
    }
    await fileActions.saveXMLFile();
  }, [state.xmlDoc, fileActions]);

  const isDisabled = !state.xmlDoc;

  return (
    <div className="save-buttons">
      <button 
        onClick={handleSave}
        disabled={isDisabled}
        className="save-btn"
        title={isDisabled ? 'No XML file loaded' : 'Save changes to current file'}
      >
        Save Changes
      </button>
    </div>
  );
}
